import React, { useEffect } from 'react';
import { gsap } from 'gsap';

import {About, Footer, Header, Skills, Work} from './container';
import {Navbar} from './components';
import './App.scss';
import Experience from './container/Experience/Experience';

const App = () => {
  useEffect(() => {
    // Create single global mouse gradient effect
    const mouseGradient = document.createElement('div');
    mouseGradient.className = 'mouse-gradient-effect';
    mouseGradient.id = 'global-mouse-gradient'; // ID único para evitar duplicados
    
    // Check if gradient already exists
    const existingGradient = document.getElementById('global-mouse-gradient');
    if (existingGradient) {
      existingGradient.remove();
    }
    
    document.body.appendChild(mouseGradient);
    
    // Mouse tracking
    const handleMouseMove = (e) => {
      gsap.to(mouseGradient, {
        x: e.clientX - 200, // Centrar el gradiente (400px/2 = 200px)
        y: e.clientY - 200,
        duration: 0.3,
        ease: "power2.out"
      });
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    
    // Cleanup
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      if (mouseGradient && mouseGradient.parentNode) {
        mouseGradient.parentNode.removeChild(mouseGradient);
      }
    };
  }, []);

  return (
    <div className ="app">
      <Navbar />
        <Header />
        <Skills />
        <Work /> 
        <Experience /> 
        <About />
        {/* <Testimonial />  */}
      <Footer />
    </div>
  )
}

export default App;